import forEach from 'lodash/forEach'

const DOWNLOAD_DELAY = 1000

function autoDownloadUrl(url: string, index: number): void {
  const a = document.createElement('a')
  a.href = url
  a.download = 'true'
  setTimeout(a.click.bind(a), index * DOWNLOAD_DELAY)
}

export default function autoDownloadUrls(urls: string[]): void {
  forEach(urls, autoDownloadUrl)
}
